// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecurringContributionResponseDto } from './IRecurringContributionResponseDto';
import {
    IRecurringContributionResponseDtoFromJSON,
    IRecurringContributionResponseDtoFromJSONTyped,
    IRecurringContributionResponseDtoToJSON,
    IRecurringContributionResponseDtoToJSONTyped,
} from './IRecurringContributionResponseDto';
import type { IIrsLimitDto } from './IIrsLimitDto';
import {
    IIrsLimitDtoFromJSON,
    IIrsLimitDtoFromJSONTyped,
    IIrsLimitDtoToJSON,
    IIrsLimitDtoToJSONTyped,
} from './IIrsLimitDto';

/**
 * 
 * @export
 * @interface IRecurringContributionAggregateResponseDto
 */
export interface IRecurringContributionAggregateResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof IRecurringContributionAggregateResponseDto
     */
    is_with_catch_up_age?: boolean;
    /**
     * 
     * @type {IRecurringContributionResponseDto}
     * @memberof IRecurringContributionAggregateResponseDto
     */
    recurring_contribution_dto?: IRecurringContributionResponseDto;
    /**
     * 
     * @type {Array<IIrsLimitDto>}
     * @memberof IRecurringContributionAggregateResponseDto
     */
    irs_limits?: Array<IIrsLimitDto>;
}

/**
 * Check if a given object implements the IRecurringContributionAggregateResponseDto interface.
 */
export function instanceOfIRecurringContributionAggregateResponseDto(value: object): value is IRecurringContributionAggregateResponseDto {
    return true;
}

export function IRecurringContributionAggregateResponseDtoFromJSON(json: any): IRecurringContributionAggregateResponseDto {
    return IRecurringContributionAggregateResponseDtoFromJSONTyped(json, false);
}

export function IRecurringContributionAggregateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecurringContributionAggregateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_with_catch_up_age': json['is_with_catch_up_age'] == null ? undefined : json['is_with_catch_up_age'],
        'recurring_contribution_dto': json['recurring_contribution_dto'] == null ? undefined : IRecurringContributionResponseDtoFromJSON(json['recurring_contribution_dto']),
        'irs_limits': json['irs_limits'] == null ? undefined : ((json['irs_limits'] as Array<any>).map(IIrsLimitDtoFromJSON)),
    };
}

export function IRecurringContributionAggregateResponseDtoToJSON(json: any): IRecurringContributionAggregateResponseDto {
    return IRecurringContributionAggregateResponseDtoToJSONTyped(json, false);
}

export function IRecurringContributionAggregateResponseDtoToJSONTyped(value?: IRecurringContributionAggregateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_with_catch_up_age': value['is_with_catch_up_age'],
        'recurring_contribution_dto': IRecurringContributionResponseDtoToJSON(value['recurring_contribution_dto']),
        'irs_limits': value['irs_limits'] == null ? undefined : ((value['irs_limits'] as Array<any>).map(IIrsLimitDtoToJSON)),
    };
}

